import { render, staticRenderFns } from "./GalleriesPricelist.vue?vue&type=template&id=de901d34&scoped=true&"
import script from "./GalleriesPricelist.vue?vue&type=script&lang=js&"
export * from "./GalleriesPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de901d34",
  null
  
)

export default component.exports